import React from 'react'
import { connect } from 'react-redux';
import { Input, Button, Modal } from 'antd';
import { localization } from '../../../../Utils/Localization/localization';
import { SelectLevel } from './SelectLevel';
import { languageSelector } from '../../../../Redux/Reducers/settingsReducer';
import {
  newAdminSelector,
  addAdmin,
  setNewAdmin,
  addAdminStatusSelector
} from '../../../../Redux/Reducers/adminsReducer';
import classes from './ProfilePage.module.scss';

interface StateProps {
  language: string,
  newAdmin: any,
  status: string
}
interface DispatchProps {
  setNewAdmin: (name: string, value: any) => void,
  addAdmin: () => void
}
interface Props extends StateProps, DispatchProps {
  userLevel: number
}

function NewAdmin(props: Props) {
  const valid = (
    props.newAdmin.id.valid
    && props.newAdmin.email.valid
    && props.newAdmin.email.valid
  );
  const permissionLevel = props.userLevel >= 2;

  React.useEffect(() => {
    if (props.status === 'valid') {
      Modal.success({
        title: localization('added', props.language)
      });
    } else if (props.status === 'invalid') {
      Modal.error({
        title: localization('error', props.language)
      });
    }
  })

  return (
    <div className={classes.NewAdmin}>
      <Input
        placeholder={localization('userId', props.language)}
        value={props.newAdmin.id.value}
        onChange={(value) => permissionLevel && props.setNewAdmin('id', value.target.value)}
      />
      <Input
        placeholder={localization('email', props.language)}
        value={props.newAdmin.email.value}
        onChange={(value) => permissionLevel && props.setNewAdmin('email', value.target.value)}
      />
      <SelectLevel
        initialLevel={localization('level', props.language)}
        onChangeHandler={(value) => permissionLevel && props.setNewAdmin('level', value)}
      />
      <Button
        onClick={props.addAdmin}
        disabled={!valid || !permissionLevel}
        loading={props.status === 'loading'}
      >
        {localization('add', props.language)}
      </Button>
    </div >
  );
}

function mapStateToProps(state: any) {
  return {
    language: languageSelector(state),
    newAdmin: newAdminSelector(state),
    status: addAdminStatusSelector(state)
  }
}
const mapDispatchToProps = {
  addAdmin,
  setNewAdmin
}

const ConnectedNewAdmin = connect(mapStateToProps, mapDispatchToProps)(NewAdmin);
export { ConnectedNewAdmin as NewAdmin };